import React, { useState } from 'react'
import EventForm from './forms/event-form';
import { states } from '../utils/form';

const thankYouPath = "/thank-you/"

export default function Form({ props }) {
    const { formType } = props;
    return (
        <section className="bg-banner-gradient/10">
            <div className="container pt-12 pb-16">
                {/* {message ?
                    <div className="text-lg leading-relaxed mb-8" dangerouslySetInnerHTML={{ __html: message }} />
                    : null} */}
                {formType === "contact" ?
                    <ContactForm />
                    : formType === "event" ?
                        <EventForm />
                        : formType === "sponsorship" ?
                            <SponsorshipRequestForm />
                            : <div>{formType.toUpperCase()} form is under development. Please check back soon.</div>
                }

            </div>
        </section>
    )
}

function ContactForm() {

    const [formMessage, setFormMessage] = useState('');
    const [name, setName] = useState('');
    return <form
        netlify-honeypot="bot-field"
        data-netlify="true"
        name="contact"
        action={thankYouPath}
        method="POST"
        className="grid grid-cols-1 gap-y-5 max-w-md mx-auto">
        <input type="hidden" name="form-name" value="contact" />
        <BotField />
        <input type="hidden" name="subject"
            value={`Contact submission from ${name}: ${formMessage}`} />
        <div>
            <label className="form-label" htmlFor="name">
                Name
            </label>
            <input
                type="text"
                name="Name"
                id="name"
                required
                autoComplete='name'
                className="form-field"
                onChange={(e) => setName(e.target.value)}
            />
        </div>
        <div>
            <label className="form-label" htmlFor="name">
                Sweetwater Rewards Number (Optional)
            </label>
            <input
                type="text"
                name="Sweetwater Rewards Number"
                id="sweetwater-rewards-number"
                className="form-field"
            />
        </div>
        <div>
            <label className="form-label" htmlFor="email">
                Email address
            </label>
            <input
                id="email"
                name="Email"
                type="email"
                required
                autoComplete="email"
                className="form-field"
            />
        </div>
        <div>
            <label className="form-label" htmlFor="phone">
                Phone
            </label>
            <input
                id="phone"
                name="Phone"
                required
                type="tel"
                autoComplete="tel"
                className="form-field"
            />
        </div>
        <div>
            <label className="form-label" htmlFor="message">
                Message
            </label>
            <textarea
                id="message"
                name="Message"
                rows={4}
                className="form-field"
                onChange={(e) => setFormMessage(e.target.value)}
                defaultValue={''} />
        </div>
        <div className="text-left">
            <button
                type="submit"
                className="btn btn-primary"
            >
                Submit
            </button>
        </div>
    </form>;
}

function BotField() {
    return <p className="hidden">
        <label>
            Don’t fill this out if you’re human: <input name="bot-field" />
        </label>
    </p>;
}

function SponsorshipRequestForm() {
    const supportRequested = [
        "In-Kind Donation",
        "Sponsorship",
        "Other"
    ]
    const fileUpload = [
        1, 2, 3, 4, 5]
    // const [fileUploadCount, setFileUploadCount] = useState(2);
    return (
        <form
            netlify-honeypot="bot-field"
            data-netlify="true"
            name="Sponsorship Request"
            action={'/sponsorship-request-form/thank-you/'}
            encType="multipart/form-data"
            method="POST"
            className="grid grid-cols-1 gap-y-3 max-w-2xl mx-auto">
            <input type="hidden" name="form-name" value="Sponsorship Request" />
            <BotField />

            <div className="form-label mb-3">Fields marked with an <span className="text-red-500">*</span> are required</div>

            <div>
                <label htmlFor="form-organization" id="organization-label" className="form-label">
                    Organization <span className="text-red-500">*</span>
                </label>

                <input type="text" className="form-field" id="form-organization" name="Organization" autocomplete="organization" aria-labelledby="organization-label" aria-required="true" required="true" />
            </div>
            <div>
                <label htmlFor="form-address-line1" id="address-line1-label" className="form-label">
                    Address 1 <span className="text-red-500">*</span>
                </label>

                <input type="text" className="form-field" id="form-address-line1" name="Address 1" autocomplete="address-line1" aria-labelledby="address-line1-label" aria-required="true" required="true" />
            </div>
            <div>
                <label htmlFor="form-address-line2" id="address-line2-label" className="form-label">
                    Address 2
                </label>

                <input type="text" className="form-field" id="form-address-line2" name="Address 2" autocomplete="address-line2" aria-labelledby="address-line2-label" />
            </div>
            <div>
                <label htmlFor="form-city" id="city-label" className="form-label">
                    City <span className="text-red-500">*</span>
                </label>

                <input type="text" className="form-field" id="form-city" name="City" aria-labelledby="city-label" aria-required="true" required="true" />
            </div>
            <div>
                <label htmlFor="form-state" id="state-label" className="form-label">
                    US State <span className="text-red-500">*</span>
                </label>
                <select
                    name="State"
                    className="form-field"
                    autoComplete="state"
                    required
                    aria-labelledby="state-label"
                >
                    {states.map((state) => (
                        <option
                            key={state.value}
                            value={state.value}
                        >
                            {state.label}
                        </option>
                    ))}
                </select>
            </div>

            <div>
                <label htmlFor="form-zip" id="zip-label" className="form-label">
                    Zip <span className="text-red-500">*</span>
                </label>

                <input type="text" className="form-field" id="form-zip" name="Zip" autocomplete="postal-code" aria-labelledby="zip-label" aria-required="true" required="true" />
            </div>

            <div>
                <label htmlFor="form-contact-name" id="contact-name-label" className="form-label">
                    Contact Name <span className="text-red-500">*</span>
                </label>

                <input type="text" className="form-field" id="form-contact-name" name="Contact Name" autocomplete="name" aria-labelledby="contact-name-label" aria-required="true" required="true" />
            </div>
            <div>
                <label htmlFor="form-contact-phone" id="contact-phone-label" className="form-label">
                    Contact Phone <span className="text-red-500">*</span>
                </label>

                <input type="tel" className="form-field" id="form-contact-phone" name="Contact Phone" autocomplete="tel" aria-labelledby="contact-phone-label" aria-required="true" required="true" />
            </div>
            <div>
                <label htmlFor="form-contact-email" id="contact-email-label" className="form-label">
                    Contact Email <span className="text-red-500">*</span>
                </label>

                <input type="email" className="form-field" id="form-contact-email" name="Contact Email" autocomplete="email" aria-labelledby="contact-email-label" aria-required="true" required="true" />
            </div>
            <div>
                <label htmlFor="form-organization-website" id="organization-website-label" className="form-label">
                    Organization Website (if applicable)
                </label>

                <input type="text" className="form-field" id="form-organization-website" name="Organization Website" autocomplete="url" aria-labelledby="organization-website-label" />
            </div>
            <div>
                <label htmlFor="form-organization-type" id="organization-type-label" className="form-label">
                    Organization Type <span className="text-red-500">*</span>
                </label>

                <textarea rows="4" className="form-field" id="form-organization-type" name="Organization Type" aria-labelledby="organization-type-label" aria-required="true" required="true"></textarea>
            </div>
            <div>
                <label htmlFor="form-sponsorship-description" id="sponsorship-description-label" className="form-label">
                    Sponsorship Description <span className="text-red-500">*</span>
                </label>

                <textarea rows="8" className="form-field" id="form-sponsorship-description" name="Sponsorship Description" aria-labelledby="sponsorship-description-label" aria-required="true" required="true"></textarea>
            </div>
            <div>
                <label htmlFor="form-sponsorship-amount-requested" id="sponsorship-amount-requested-label" className="form-label">
                    Sponsorship Amount Requested <span className="text-red-500">*</span>
                </label>

                <input type="text" className="form-field" id="form-sponsorship-amount-requested" name="Sponsorship Amount Requested" autocomplete="name" aria-labelledby="sponsorship-amount-requested-label" aria-required="true" required="true" />
            </div>

            <hr className="my-4" />

            <h2>Event Information</h2>

            <div>
                <label htmlFor="form-event-name" id="event-name-label" className="form-label">
                    Event Name <span className="text-red-500">*</span>
                </label>

                <input type="text" className="form-field" id="form-event-name" name="Event Name" aria-labelledby="event-name-label" aria-required="true" required="true" />
            </div>

            <div>
                <label htmlFor="form-event-date" id="event-date-label" className="form-label">
                    Event Date <span className="text-red-500">*</span>
                </label>

                <input type="text" className="form-field" id="form-event-date" name="Event Date" placeholder="MM/DD/YYYY" aria-labelledby="event-date-label" aria-required="true" required="true" />
            </div>
            <div>
                <label htmlFor="form-event-number-of-people-expected" id="event-number-of-people-expected-label" className="form-label">
                    Number of People Expected
                </label>

                <input type="text" className="form-field" id="form-event-number-of-people-expected" name="Event Number of People Expected" aria-labelledby="event-number-of-people-expected-label" />
            </div>
            <div>
                <label htmlFor="form-event-deadline-for-marketing-material" id="event-deadline-for-marketing-material-label" className="form-label">
                    Event Deadline for Marketing Material <span className="text-red-500">*</span>
                </label>

                <input type="text" className="form-field" id="form-event-deadline-for-marketing-material" name="Event Deadline For Marketing Material" placeholder="MM/DD/YYYY" aria-labelledby="event-deadline-for-marketing-material-label" aria-required="true" required="true" />
            </div>
            <div>
                <label htmlFor="form-event-support-requested" id="event-support-requested-label" className="form-label">
                    Support Requested <span className="text-red-500">*</span>
                </label>
                <select
                    name="Event Support Requested"
                    className="form-field"
                    required
                    aria-labelledby="event-support-requested-label"
                >
                    {supportRequested.map((supportRequestedOption) => (
                        <option
                            key={supportRequestedOption}
                            value={supportRequestedOption}
                        >
                            {supportRequestedOption}
                        </option>
                    ))}
                </select>
            </div>

            <hr className="my-4" />

            <h2>Event Contact Information</h2>
            <div>
                <label htmlFor="form-event-contact-name" id="event-contact-name-label" className="form-label">
                    Name <span className="text-red-500">*</span>
                </label>

                <input type="text" className="form-field" id="form-event-contact-name" name="Event Contact Name" autocomplete="name" aria-labelledby="event-contact-name-label" aria-required="true" required="true" />
            </div>
            <div>
                <label htmlFor="form-address" id="address-label" className="form-label">
                    Address
                </label>

                <input type="text" className="form-field" id="form-address" name="Event Contact Address" autocomplete="street-address" aria-labelledby="address-label" />
            </div>
            <div>
                <label htmlFor="form-event-contact-email" id="event-contact-email-label" className="form-label">
                    Email <span className="text-red-500">*</span>
                </label>

                <input type="email" className="form-field" id="form-event-contact-email" name="Event Contact Email" autocomplete="email" aria-labelledby="event-contact-email-label" aria-required="true" required="true" />
            </div>
            <div>
                <label htmlFor="form-event-contact-phone" id="event-contact-phone-label" className="form-label">
                    Phone
                </label>

                <input type="tel" className="form-field" id="form-event-contact-phone" name="Event Contact Phone" autocomplete="tel" aria-labelledby="event-contact-phone-label" />
            </div>

            <div>
                <div className="mb-4 parsed-content">
                    <p className="form-label">File Upload <span className="text-red-500">*</span></p>
                    <ul>
                        <li>Submit a copy of your 501(c)(3) designation letter from the IRS (mandatory)</li>
                        <li>Provide a list of sponsorship levels, if applicable</li>
                    </ul>
                    <p>If a request is for $2,000 or greater, include:</p>
                    <ul>
                        <li>An informational brochure on your organization and the geographic area it covers</li>
                        <li>A mission statement and percentage of budget used for administrative costs</li>
                        <li>A description of the specific program, project, or event being funded</li>
                    </ul>
                    <p>File upload limitations:</p>
                    <ul>
                        <li>Max file size limit: 8 MB per submission</li>
                        <li>Min files: 1; max files: 5</li>
                        <li>File uploads time out after 30 seconds</li>
                    </ul>
                </div>
                {fileUpload.map(
                    (fileUploadOption) => (
                        <label>
                            <span className="form-label">File {fileUploadOption} {fileUploadOption === 1 ? <span className="text-red-500">*</span> : null}</span>
                            <input type="file" name={`File ${fileUploadOption}`} class="w-full lg:pb-2 file:bg-white file:py-1 file:px-2 file:transition cursor-pointer file:cursor-pointer file:hover:bg-green file:hover:text-white file:text-body file:text-sm file:border file:border-green file:rounded" required={fileUploadOption === 1 ? true : false} aria-required={fileUploadOption === 1 ? true : false} />
                        </label>)
                )}

            </div>
            <div className="text-left mt-6">
                <button
                    type="submit"
                    className="btn btn-primary"
                >
                    Submit
                </button>
            </div>

        </form>)
}
